module.exports = __webpack_public_path__ + "static/media/wave-page-top.930e098c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wave-page-top.svg
// module id = 597
// module chunks = 0